import { useT } from '../../hooks/useTranslation';
import { useLanguage } from '../../context/LanguageContext';
import { useSeoMeta } from '../../hooks/useSeoMeta';

const SITE_URL = 'https://haaziko.hu/';
// JPG, mert a Facebook/LinkedIn/Twitter crawler nem kezeli az AVIF-et (1200×630).
const OG_IMAGE = 'https://haaziko.hu/og-image.jpg';

/**
 * Nyelvfüggő title/meta a főoldalhoz. Az index.html-ben lévő statikus meta a
 * magyar alapértelmezés (ezt látja a crawler JS nélkül is); ez a komponens
 * ugyanazokat a tageket írja felül nyelvváltáskor. Canonical mindig a gyökér —
 * a nyelvváltás kliens-oldali, nincs külön EN URL, ezért hreflang sincs.
 */
export const SEO = () => {
  const t = useT();
  const { lang } = useLanguage();

  useSeoMeta({
    title: t.seo.title,
    lang,
    canonical: SITE_URL,
    meta: {
      title: t.seo.title,
      description: t.seo.description,
      robots: 'index, follow, max-image-preview:large',
      'og:url': SITE_URL,
      'og:locale': lang === 'en' ? 'en_US' : 'hu_HU',
      'og:title': t.seo.ogTitle,
      'og:description': t.seo.ogDescription,
      'og:image': OG_IMAGE,
      'twitter:title': t.seo.ogTitle,
      'twitter:description': t.seo.ogDescription,
      'twitter:image': OG_IMAGE,
    },
  });

  return null;
};
